import { createContext, useContext } from "react";
import { allInstanceData, config } from "../config";
import { useEffect } from "react";
import { getOrginizationDetails } from "../utils/actions/userActions";
import { useState } from "react";

const InstanceContext = createContext(config);

export const useInstance = () => useContext(InstanceContext);

export const InstanceProvider = ({ children }) => {
    const [data, setData] = useState({});
    useEffect(() => {
        const favIconElement = document.querySelector(`link[rel="icon"]`) || document.createElement("link");
        favIconElement.rel = "icon";
        if (allInstanceData.NDCS == config.name) {
            favIconElement.href = `/ndcs_fav_icon.ico`;
        }
        if (allInstanceData._8xPart == config.name) {
            favIconElement.href = `/_8xpart_fav_icon.ico`;
        }
        console.log("Fav Icon Element :", favIconElement);
        document.head.appendChild(favIconElement);

    }, []);


    useEffect(() => {

        (async () => {
            try {
                console.log("run ");
                const response = await getOrginizationDetails();
                
                if (!response || !response.success) {
                    throw new Error(response.message);
                }
                const { data } = response;
                const { organizationName } = data;
                document.querySelector("title").innerHTML = organizationName + ' supplier';
                console.log("Fetched Data :",data);
                setData(data);

            } catch (error) {
                console.log("Error :", error);
            }
        })()
    }, []);


    return (
        <InstanceContext.Provider value={{ ...config, ...data, allInstanceData }}>
            {children}
        </InstanceContext.Provider>
    )
}